<template>
  <div class="page" v-if="activePage">
    <!-- TODO transiting between page types better -->
    <transition name="fade">
      <events v-if="activePage && activePage.type === 'events'"></events>
      <place v-if="activePage && activePage.type === 'place'"></place>
      <gallery v-if="activePage && activePage.type === 'gallery'"></gallery>
      <interactive-tags v-if="activePage && activePage.type === 'interactiveTags'"></interactive-tags>
    </transition>
    <!-- <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="'/assets/tas-mini.jpg'"
      :heading="activePage.heading[language.code]"
      :description="activePage.description[language.code]"
      :qr-url="activePage.qrUrl"
    /> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Events from '@/components/Events'
import Place from '@/components/Place'
import Gallery from '@/components/Gallery'
import InteractiveTags from '@/components/InteractiveTags'
import RightSidebar from '@/components/RightSidebar'
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'page',

  components: { Events, Place, RightSidebar, Gallery, InteractiveTags, QrcodeVue },

  data () {
    return {
      animating: false,
      sidebarNavigationItems: []
    }
  },

  computed: {
    ...mapGetters([
      'activePage',
      'activeSubNavigation',
      'language'
    ]),

    showQrCode () {
      return Boolean(this.activePage.qrUrl.length)
    }
  },

  mounted () {
    this.updateSidebarNavigationItems()
  },

  watch: {
    activeSubNavigation () {
      this.updateSidebarNavigationItems()
    }
  },

  methods: {
    updateSidebarNavigationItems () {
      let sidebarNavigationItems = []
      if (this.activeSubNavigation) {
        this.activeSubNavigation.forEach(_item => {
          let item = {
            to: this.$route.path.includes('live') ? `/live/page/${_item.pageId}` : `/category/${this.$store.state.route.params.categoryId}/page/${_item.pageId}`,
            label: _item.label[this.language.code],
            icon: _item.icon
          }
          sidebarNavigationItems.push(item)
        })
      }
      this.sidebarNavigationItems = sidebarNavigationItems      
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";

.place {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &__image-container {
    height: 98rem;
    left: 0;
    position: absolute;
    top: 0;
    width: 152rem;
  }

  &__image {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
}

.qr {
  display: flex;
  font-size: 1.6rem;
  line-height: 1.2;
  margin: auto 0 0;

  &__content {
    display: flex;
    flex-direction: column;
    margin: 0 0 0 1rem;
  }

  &__message {
    color: $basecolor;
    font-size: 1.1rem;
    font-weight: 200;
    margin-bottom: 1em;
    text-transform: uppercase;
  }

  &__instruction {
    font-size: .85rem;
    font-weight: 200;
    margin-bottom: 1em;
  }

  .qrcode {
    background: white;
    display: inline-block;
    height: 5rem;
    padding: .5rem;

    canvas {
      height: 4rem !important;
      width: 4rem !important;
    }
  }
}
</style>


